import { login,requestOTP,submitOTP, signup } from 'api/auth';
import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';

function useLogin() {
  const { enqueueSnackbar } = useSnackbar();
  return useMutation(login, {
    onError: (err) => enqueueSnackbar(err.message, { variant: 'error' }),
    onSuccess: () => enqueueSnackbar('شما با موفقیت وارد پنل شدید.', { variant: 'success' }),
  });
}

function useRequestOTP() {
  const { enqueueSnackbar } = useSnackbar();
  return useMutation(requestOTP, {
    onError: (err) => enqueueSnackbar(err.message, { variant: 'error' }),
    onSuccess: () => enqueueSnackbar('کد ورود به شماره شما ارسال شد', { variant: 'success' }),
  });
}

function useSubmitOTP(){
  const { enqueueSnackbar } = useSnackbar();
  return useMutation(submitOTP, {
    onError: (err) => enqueueSnackbar(err.message, { variant: 'error' }),
    onSuccess: () => enqueueSnackbar('شما با موفقیت وارد شدید.', { variant: 'success' }),
  });
}

function useSignup(){
  const { enqueueSnackbar } = useSnackbar();
  return useMutation(signup, {
    onError: (err) => enqueueSnackbar(err.message, { variant: 'error' }),
    onSuccess: () => enqueueSnackbar('پروفایل شما با موفقیت تکمیل شد. اکنون می توانید از امکانات سیستم استفاده کنید.', { variant: 'success' }),
  });
}

export { useLogin,useRequestOTP,useSubmitOTP, useSignup };
